import { KIDS_ROUTE_ENABLED } from "@/constants/site";

export const Header = () => {
  // Sitewide micro-interaction: shared .link-micro utility (index.css).
  const navLinkClass =
    "link-micro text-sm font-semibold text-[#4A453C] hover:text-[#14171A]";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#F5F1E6]/85 backdrop-blur-md border-b border-[#E3DBC9]"
    >
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
        <a
          data-testid="logo-link"
          href="#top"
          className="flex items-center py-1"
          aria-label="NISCHINT home"
        >
          <img src="/logo.png" alt="NISCHINT" className="h-20 w-auto" width={637} height={624} />
        </a>
        <nav className="flex items-center gap-6">
          <a data-testid="plans-link" href="/plans" className={navLinkClass}>
            Plans
          </a>
          {KIDS_ROUTE_ENABLED && (
            <a data-testid="kids-link" href="/kids" className={navLinkClass}>
              For Kids
            </a>
          )}
          <a data-testid="about-link" href="/about" className={navLinkClass}>
            About
          </a>
          <a data-testid="blog-link" href="/blog" className={navLinkClass}>
            Blog
          </a>
          <a data-testid="login-signup-link" href="/#waitlist" className={navLinkClass}>
            Login / Signup
          </a>
        </nav>
      </div>
    </header>
  );
};
